var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionButton',{attrs:{"title":_vm.$t('maintenance_detail.comments'),"icon":"mdi-comment-plus","action":_vm.goComments}})
}
var staticRenderFns = []

export { render, staticRenderFns }